import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MenuServices } from "../../services";
import { Globals } from "../../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { MenuCreateSelectTypePage } from '../menu-create-select-type/menu-create-select-type';

/**
 * Generated class for the MenuCreateTitlePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-menu-create-title',
  templateUrl: 'menu-create-title.html',
})
export class MenuCreateTitlePage {
  type: any;
  public form: FormGroup;
  menu_uid: string;
  menu_name: string;
  update_state: boolean = false;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public menuServices: MenuServices,
    public globals: Globals,
    public fb: FormBuilder,
    private toastCtrl: ToastController,
    public translate: TranslateService) {

    this.update_state = this.navParams.get('update');
    this.menu_uid = this.navParams.get('menu_uid');
    this.menu_name = this.navParams.get('menu_name');


    if (this.update_state) {
      this.form = fb.group({
        reference: [String(this.navParams.get('reference')), Validators.compose([Validators.required])],
        title_es: [this.navParams.get('title_es')],
        title_ca: [this.navParams.get('title_ca')],
        title_en: [this.navParams.get('title_en')],
        title_de: [this.navParams.get('title_de')],
        title_it: [this.navParams.get('title_it')],
        title_fr: [this.navParams.get('title_fr')],
        subtitle: [this.navParams.get('subtitle')],
      });
    } else {
      this.form = fb.group({
        reference: ['', Validators.compose([Validators.required])],
        title_es: [''],
        title_ca: [''],
        title_en: [''],
        title_de: [''],
        title_it: [''],
        title_fr: [''],
        subtitle: [''],
      });
    }



  }


  ionViewWillEnter() {
  }

  submit() {
    if (this.form.valid) {
      //Update
      this.update();
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-introduce-referencia-titulo-menu-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  update() {
    if (this.update_state) {//EDITAR
      this.globals.GAtrackView('Menu', 'Menu - Name - Update', this.globals.restaurant.email, 'Create/Update', 'Update name', 'Menu', this.form.value.title_es);
      this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
        'reference': String(this.form.value.reference),
        'title_es': this.form.value.title_es,
        'title_en': this.form.value.title_en,
        'title_fr': this.form.value.title_fr,
        'title_de': this.form.value.title_de,
        'title_it': this.form.value.title_it,
        'title_ca': this.form.value.title_ca,
        'subtitle_es': this.form.value.subtitle,
        'subtitle_en': null,
        'subtitle_fr': null,
        'subtitle_it': null,
        'subtitle_de': null,
        'subtitle_ca': null,
        'updated_at': new Date(),
      }).then(() => {
        if (this.update_state) {
          this.navCtrl.pop();
        } else {
          //this.openMenuDishesSelect();
        }
      });
    } else {//CREAR
      this.globals.GAtrackView('Menu', 'Menu - Name - Create', this.globals.restaurant.email, 'Create/Update', 'Create name', 'Menu', this.form.value.title_es);
      this.menuServices.afs.collection('menus').add({
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'style': 'basic',
        'separator': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/separators%2Fseparador3.png?alt=media&token=1f0e9059-bd6a-49e8-a8e4-18c1e9ec3a11',
        'template': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/templates%2Ffons_mct_blanc.png?alt=media&token=15455e42-1097-4eb0-bb47-1d29ef9622d5',
        'logo_show': true,
        'caption_show': false,
        'enumerate': false,
        'footer_show': true,
        'footer_font_color': '#000',
        'footer_font_family': 'Arial',
        'footer_font_size': '18',
        'footer_text_align': 'center',
        'header_font_color': '#000',
        'header_font_family': 'Arial',
        'header_font_size': '18',
        'header_text_align': 'center',
        'reference': String(this.form.value.reference),
        'title_es': this.form.value.title_es,
        'title_en': this.form.value.title_en,
        'title_fr': this.form.value.title_fr,
        'title_de': this.form.value.title_de,
        'title_it': this.form.value.title_it,
        'title_ca': this.form.value.title_ca,
        'subtitle_es': this.form.value.subtitle,
        'subtitle_en': null,
        'subtitle_fr': null,
        'subtitle_it': null,
        'subtitle_de': null,
        'subtitle_ca': null,
        'extra': 0,
        'price': 0,
        'extras_footer': [],
        'sections': {},
        'created_at': new Date(),
        'digital_app': false,
        'template_name': 'multipla',
        'type': 'menu',
        'tax': this.globals.RESTAURANT_TAX
      }).then(doc => {
        this.globals.tourLaunchStep(5);

        this.menu_uid = doc.id;

        if (this.update_state) {
          this.navCtrl.pop();
        } else {
          this.navCtrl.push(MenuCreateSelectTypePage, {
            template_name: 'multipla',
            update: this.update_state,
            menu_uid: this.menu_uid
          });
        }
      });
    }

  }

  /*getsections() {
    var ret;
    if (this.type == 'basic') {
      ret = {
        0: {
          dish: Array(),
          name: 'Primeros'
        },
        1: {
          dish: Array(),
          name: 'Segundos'
        },
        2: {
          dish: Array(),
          name: 'Postres'
        }
      }

    } else if (this.type == 'buffete') {
      ret = {
        0: {
          dish: Array(),
          name: 'Buffete'
        },
      }

    } else if (this.type == 'aperitivo') {
      ret = {
        0: {
          dish: Array(),
          name: 'Aperitivo'
        },
        1: {
          dish: Array(),
          name: 'Primeros'
        },
        2: {
          dish: Array(),
          name: 'Segundos'
        },
        3: {
          dish: Array(),
          name: 'Postres'
        }
      }
    } else {
      ret = {
        0: {
          dish: Array(),
          name: 'Todos'
        },
      }
    }
    return ret;
  }*/

  /*openMenuDishesSelect() {
    this.navCtrl.push(MenuCreateDishSelectPage, {
      type: this.type,
      section: '0',
      update: this.update_state,
      menu_uid: this.menu_uid,
    });
  }*/


}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-create/menu-create-title/menu-create-title.ts